export default "__VITE_ASSET__BLQHx2at__"